(function () {
  'use strict';

  if (!document.body.classList.contains('lb-cloud-scroll-site')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var cloudField = document.querySelector('.lb-cloud-field');
  var isHome = document.body.classList.contains('lb-colette-home');
  var ticking = false;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function updateScroll() {
    var scrollY = window.scrollY || window.pageYOffset;
    var viewport = window.innerHeight || 1;
    var docHeight = Math.max(
      document.documentElement.scrollHeight - viewport,
      viewport
    );
    var heroProgress = clamp(scrollY / viewport, 0, 1.35);
    var pageProgress = clamp(scrollY / docHeight, 0, 1);

    root.style.setProperty('--lb-scroll', heroProgress.toFixed(4));
    root.style.setProperty('--lb-page-scroll', pageProgress.toFixed(4));
    root.style.setProperty('--lb-scroll-y', scrollY + 'px');

    if (cloudField) {
      var speed = isHome ? 0.58 : 0.4;
      cloudField.style.setProperty('--lb-cloud-shift', (-scrollY * speed).toFixed(2) + 'px');
      cloudField.style.setProperty('--lb-cloud-shift-2', (-scrollY * 0.22).toFixed(2) + 'px');
      cloudField.style.setProperty('--lb-cloud-drift', (Math.sin(scrollY * 0.003) * 24).toFixed(2) + 'px');
      cloudField.style.setProperty('--lb-cloud-veil', clamp(heroProgress * 0.75, 0, 1).toFixed(4));
      cloudField.style.setProperty('--lb-cloud-depth', pageProgress.toFixed(4));
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateScroll);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  updateScroll();
})();
